import React, { CSSProperties } from 'react'
import './index.less'
import {AppTable,AppGridLayoutContext,AppTableSearch,AppFilter} from 'qcc'

export interface AppGridLayoutProps {
    onsearch?:any
    style?:CSSProperties;
}

export class AppGridLayout extends React.Component<AppGridLayoutProps>{
    state = {refTable:null as AppTable}

    static SearchArea: React.FC<{children?:any}> = props =>{
        return (<div className='app-grid-layout-search-area'>
                    <AppGridLayoutContext.Consumer>
                        {consumer =>{
                            return React.Children.map(props.children, (child: any) =>{
                                let onSearch = child.props.onSearch || consumer.onSearch;
                                return child.type === AppTableSearch ? React.cloneElement(child, {onSearch}):child;
                               })
                        }}
                    </AppGridLayoutContext.Consumer>
                </div>)
    }

    static MenuArea : React.FC<{children?:any}> = props =>{
        return <div className='app-grid-layout-menu-area'>{props.children}</div>
    }

    static GridArea : React.FC<{children?:any}> = props =>{
        return (<div className='app-grid-layout-grid-area'>
                <AppGridLayoutContext.Consumer>
                    {consumer =>{
                        return React.Children.map(props.children, (child: any) =>{
                            return child.type === AppTable ? React.cloneElement(child, {exportRef: consumer.setRefTable}) 
                                                            : child;
                            })
                    }}
                </AppGridLayoutContext.Consumer>
        </div>)
    }
    
    setRefTable = (refTable?:AppTable) =>{
        this.setState({refTable});
    }

    onSearch=(filterList?:AppFilter[],data?:any) =>{
        let {refTable} = this.state;
        refTable.onQuery(filterList,data);
	}

    refGridLayout = React.createRef<HTMLDivElement>();
    render () {
        let {refTable} = this.state;
        let {setRefTable,onSearch} = this;
        return (<AppGridLayoutContext.Provider value={{refTable,setRefTable,onSearch}}>
        <div className='app-grid-layout-container' style={this.props.style}>
            <div className='app-grid-layout' ref={this.refGridLayout}>
                {this.props.children}
            </div>
        </div>
        </AppGridLayoutContext.Provider>
        )
    }
}


// WEBPACK FOOTER //
// ./src/qcc/AppGridLayout/AppGridLayout.tsx